import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

export function getDrawerSxTransitionMixin(
  isExpanded: boolean,
  property: string,
): SxProps<Theme> {
  return {
    transition: (theme: Theme) =>
      theme.transitions.create(property, {
        easing: theme.transitions.easing.sharp,
        duration: isExpanded
          ? theme.transitions.duration.enteringScreen
          : theme.transitions.duration.leavingScreen,
      }),
  } as SxProps<Theme>;
}

export function getDrawerWidthTransitionMixin(
  isExpanded: boolean,
): SxProps<Theme> {
  return {
    ...getDrawerSxTransitionMixin(isExpanded, "width"),
    overflowX: "hidden",
  } as SxProps<Theme>;
}
